import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import ChatTextMessageItem from "./MessageItems/ChatTextMessageItem";
import ChatImageMessageItem from "./MessageItems/ChatImageMessageItem";
import ChatLocationMessageItem from "./MessageItems/ChatLocationMessageItem";
import ChatBizEmojiMessageItem from "./MessageItems/ChatBizEmojiMessageItem";
import { MessageIOType, FHTMessageType } from "@/models/MessageTypes";
import ChatUnsupportedMessageItem from "./MessageItems/ChatUnsupportedMessageItem";
import RichCustomChatMessageDto from "@/models/messages/RichCustomChatMessageDto";
import ChatTopicPostMessageItem from "./MessageItems/ChatTopicPostMessageItem";
import ChatCompanyCardMessageItem from "./MessageItems/ChatCompanyCardMessageItem";
import ChatStatusMessageItem from "./MessageItems/ChatStatusMessageItem";
import ChatNameCardMessageItem from "./MessageItems/ChatNameCardMessageItem";
import ChatProductMessageItem from "./MessageItems/ChatProductMessageItem";
import ChatMeetupMessageItem from "./MessageItems/ChatMeetupMessageItem";
import { formatImageUrl } from "@/common/utils";
import ChatRecalledMessageItem from "./MessageItems/ChatRecalledMessageItem";
import { assert } from "@/common/assert";
import ChatForwardMessageItem from "./MessageItems/ChatForwardMessageItem";
import { isStatusMessage } from "./chatRoomUtils";
import { IS_DEV } from "@/common/fhtGlobalEnv";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
/**
 * Regular means not ChatStatusRoomMessage
 */

function RegularMessageWrapper(props) {
  switch (props.message.messageType) {
    case FHTMessageType.Text:
      return _jsx(ChatTextMessageItem, {
        message: props.message
      }, void 0);

    case FHTMessageType.Image:
      return _jsx(ChatImageMessageItem, {
        message: props.message,
        onClickImage: props.onClickImage
      }, void 0);

    case FHTMessageType.Location:
      return _jsx(ChatLocationMessageItem, {
        message: props.message
      }, void 0);

    case FHTMessageType.Recalled:
      return _jsx(ChatRecalledMessageItem, {
        message: props.message
      }, void 0);

    case FHTMessageType.Unsupported:
      return _jsx(ChatUnsupportedMessageItem, {
        message: props.message
      }, void 0);

    case FHTMessageType.RichCustomMessage:
      var cm = props.message;

      switch (cm.customType) {
        case FhtLeancloudCustomMessageType.TopicPost:
          return _jsx(ChatTopicPostMessageItem, {
            message: props.message
          }, void 0);

        case FhtLeancloudCustomMessageType.Product:
          return _jsx(ChatProductMessageItem, {
            message: props.message
          }, void 0);

        case FhtLeancloudCustomMessageType.NameCard:
          return _jsx(ChatNameCardMessageItem, {
            message: props.message
          }, void 0);

        case FhtLeancloudCustomMessageType.CompanyCard:
          return _jsx(ChatCompanyCardMessageItem, {
            message: props.message,
            myself: props.myself,
            onJoinCompany: props.onJoinCompany
          }, void 0);

        case FhtLeancloudCustomMessageType.Meetup:
          return _jsx(ChatMeetupMessageItem, {
            message: props.message
          }, void 0);

        case FhtLeancloudCustomMessageType.BusinessEmoji:
          return _jsx(ChatBizEmojiMessageItem, {
            message: props.message
          }, void 0);

        case FhtLeancloudCustomMessageType.Forward:
          var m = props.message;
          assert(m instanceof RichCustomChatMessageDto, "m not RichCustom");
          return _jsx(ChatForwardMessageItem, {
            message: m
          }, void 0);

        case FhtLeancloudCustomMessageType.DataSync:
          return null;

        case FhtLeancloudCustomMessageType.ChatRoomStatus:
          throw new Error("You should handle ChatRoomStatus UI differently outside");

        default:
          assert(false, "TODO support custom message of type: " + cm.customType);
          return null;
      }

    default:
      console.log("Oops, unknown message type", props.message);
      throw new Error("Oops, unknown message type");
  }
}

var ChatMessageItem =
/** @class */
function (_super) {
  __extends(ChatMessageItem, _super);

  function ChatMessageItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ChatMessageItem.prototype.render = function () {
    var _a = this.props,
        message = _a.message,
        myself = _a.myself,
        contact = _a.contact,
        onClickImage = _a.onClickImage,
        onJoinCompany = _a.onJoinCompany;
    var info = contact.getContactInfo();
    var messageOwner;
    var messageClass;
    var avatarUrl = formatImageUrl(info.avatarUrl, ImageSizeTypeEnum.Thumbnail44whFill);

    if (message.MessageIOType === MessageIOType.Received && !isStatusMessage(message)) {
      messageClass = "chat-message-item chat-message-item--received";
      messageOwner = _jsx("a", __assign({
        className: "chat-message-item__avatar",
        href: info.linkUrl,
        target: "_blank"
      }, {
        children: _jsx("img", {
          src: avatarUrl,
          alt: info.name,
          title: info.name
        }, void 0)
      }), void 0);
    } else if (message.MessageIOType === MessageIOType.Sent && !isStatusMessage(message)) {
      messageClass = "chat-message-item chat-message-item--sent";
      messageOwner = _jsx("a", __assign({
        className: "chat-message-item__avatar",
        href: myself.url,
        target: "_blank"
      }, {
        children: _jsx("img", {
          src: myself.avatarUrl,
          title: "\u6211"
        }, void 0)
      }), void 0);
    } else {
      messageClass = "chat-message-item chat-message-item--status";
      messageOwner = null;
    }

    function isCustomCard(message) {
      switch (message.customType) {
        case FhtLeancloudCustomMessageType.TopicPost:
          return true;

        case FhtLeancloudCustomMessageType.Product:
          return true;

        case FhtLeancloudCustomMessageType.NameCard:
          return true;

        case FhtLeancloudCustomMessageType.CompanyCard:
          return true;

        case FhtLeancloudCustomMessageType.Meetup:
          return false;

        case FhtLeancloudCustomMessageType.BusinessEmoji:
          return false;

        default:
          return false;
      }
    }

    var actualMessageEl;
    var cm = message;

    if (cm.messageType === FHTMessageType.RichCustomMessage && cm.customType === FhtLeancloudCustomMessageType.ChatRoomStatus) {
      var m = message;
      assert(m.customAttrs, "m.body falsy");
      assert(m.customAttrs.Custom || m.customAttrs.Other, "gotta have Custom or Other");
      actualMessageEl = _jsx(ChatStatusMessageItem, {
        message: m
      }, void 0);
    } else {
      var innerClassName = message.messageType === FHTMessageType.Text ? "chat-message-item__content-inner chat-message-item__content-inner-text" : isCustomCard(cm) ? "chat-message-item__content-inner chat-message-item__content-inner-card" : "chat-message-item__content-inner";
      actualMessageEl = _jsxs("div", __assign({
        className: "chat-message-item__content"
      }, {
        children: [message.failed && _jsx("span", {
          className: "chat-message-list__failed"
        }, void 0), _jsxs("div", __assign({
          className: innerClassName
        }, {
          children: [_jsx("span", {
            className: "chat-message-item__arrow"
          }, void 0), _jsx(RegularMessageWrapper, {
            message: message,
            onClickImage: onClickImage,
            myself: myself,
            onJoinCompany: onJoinCompany
          }, void 0)]
        }), void 0)]
      }), void 0);
    }

    var title = IS_DEV ? message.id : undefined;
    return _jsxs("li", __assign({
      className: messageClass,
      title: title
    }, {
      children: [message.isTimestampShown && _jsx("div", __assign({
        className: "chat-message-item__time"
      }, {
        children: message.timestampText
      }), void 0), messageOwner, actualMessageEl]
    }), void 0);
  };

  return ChatMessageItem;
}(React.PureComponent);

export default ChatMessageItem;